// Copyright (c) 2024 by Audere

import { InputBase, Paper } from "@mui/material";

import { ChangeEvent } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { createStyleSheet } from "../utils/styles";
import { grey } from "@mui/material/colors";

interface SearchBarProps {
  onSearchChange: (search: string) => void;
  placeholder: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearchChange,
  placeholder,
}) => {
  // Handle search input change
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target instanceof HTMLInputElement) {
      onSearchChange(event.target.value);
    }
  };

  return (
    <Paper variant="outlined" component="form" sx={styles.searchBar}>
      <SearchIcon sx={{ color: grey[500] }} />
      <InputBase
        sx={styles.inputBase}
        placeholder={placeholder}
        aria-label="search conversations"
        name="search"
        onChange={handleSearchChange}
      />
    </Paper>
  );
};

const styles = createStyleSheet({
  searchBar: {
    alignItems: "center",
    backgroundColor: grey[50],
    borderRadius: 1.5,
    display: "flex",
    width: "100%",
    marginY: 1,
    padding: "4px 8px",
    "&:hover": {
      border: `1px solid ${grey[500]}`,
      backgroundColor: grey[100],
    },
  },
  inputBase: {
    color: "inherit",
    flex: 1,
    fontSize: "0.875rem",
    marginLeft: 1,
    "&.MuiInputBase-input": {
      padding: "4px 8px",
    },
  },
});

export default SearchBar;
